import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useProgramCreation } from './ProgramCreationContext';

export function ProgramCreationFlow() {
  const { state } = useProgramCreation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Se ainda não escolheu o tipo, força o usuário ficar no step "start"
    const isOnStartStep = location.pathname.endsWith('/start');

    if (!state.programType && !isOnStartStep) {
      navigate('start', { replace: true }); // <-- RELATIVO
    }
  }, [state.programType, location.pathname, navigate]);

  return <Outlet />;
}
